import script from "./DropdownButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownButton.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownButton.vue?vue&type=style&index=0&id=39676f04&lang=css"

const __exports__ = script;

export default __exports__